import { EntityMenuName, NodeWithName } from '../EntitySelectionPanelUI';
import { usePanelStateContext } from '../context';
import React, { forwardRef } from 'react';
import KubitTooltip from '../../../KubitTooltip';
import { ENTER_NEW_VALUE_HINT } from '../../../Dropdown/StyledReactSelect/CreatableReactSelectMenu';
import { ICreatableNode, ISelectableNode } from '../types';
import { areNodesEqual } from '../utils';

interface IProps {
  indent: number;
  selectedNode: ISelectableNode;
  node: ICreatableNode;
}

const CreatableNode = forwardRef<HTMLDivElement, IProps>(
  ({ selectedNode, node, indent }, ref) => {
    const { searchTerm, selectNodeHandler } = usePanelStateContext();

    const selected = areNodesEqual(node, selectedNode);

    return (
      <div ref={ref}>
        <KubitTooltip content={ENTER_NEW_VALUE_HINT} placement="bottom-start">
          <NodeWithName
            $indent={indent}
            onClick={() => selectNodeHandler(node)}
            $selected={selected}
          >
            <EntityMenuName>
              <strong>Entered</strong>: {searchTerm}
            </EntityMenuName>
          </NodeWithName>
        </KubitTooltip>
      </div>
    );
  },
);
export default CreatableNode;
